'use strict';

var React = require('react');

var SvgTwitterMinor = function SvgTwitterMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 6.25c.584-.071 1.235-.285 1.75-.513-.05.074-.097.145-.142.215-.306.466-.544.827-1.035 1.173.006.121.01.535.01.66 0 3.763-2.883 7.798-8.166 7.798-1.622 0-3.396-.375-4.667-1.18.165.02.277.018.418.015l.165-.001c1.347 0 3.1-.405 4.084-1.167-1.257-.024-3.093-.621-3.458-1.75.89 0 1.26-.15 1.493-.244.062-.025.114-.046.163-.06-1.313-.261-2.282-1.199-2.282-2.58v-.033c.388.21 1.28.57 1.75.584-.771-.512-1.746-1.59-1.746-2.65 0-.52.14-1.013.389-1.434 1.416 1.723 3.69 3.5 6.024 3.5v-1.166c0-1.572 1.107-2.917 2.693-2.917.826 0 1.572.246 2.094.8.655-.126 1.658-.474 2.213-.8-.214.664-1.156 1.398-1.75 1.75Z"
  }));
};
SvgTwitterMinor.displayName = "TwitterMinor";

exports.SvgTwitterMinor = SvgTwitterMinor;
